module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon07.28ba2db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon07.png
// module id = /Mwc
// module chunks = 0